// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"132":"forms","138":"profile","225":"rooms","796":"tables","966":"login"}[chunkId] || chunkId) + "." + {"132":"ed07b1c2","138":"2b942fde","225":"aa083267","276":"53e427af","796":"b59bf803","966":"c60db37a"}[chunkId] + ".js";
};